export const BuySellPriceRange = {
  parse: (price: string): { from: number; to: number } => {
    if (!price?.includes("__")) {
      return { from: 0, to: 0 };
    }

    const [from, to] = price.split("__");
    const fromNumber = Number.parseInt(from, 10);
    const toNumber = Number.parseInt(to, 10);
    return {
      from: Number.isNaN(fromNumber) ? 0 : fromNumber,
      to: Number.isNaN(toNumber) ? 0 : toNumber,
    };
  },

  stringify: ({ from, to }: { from: number; to: number }) => {
    return `${from}__${to}`;
  },
};
